import { makeAutoObservable } from 'mobx'

/**
 * Local store of `QRSection`.
 * Owns whether the QR code image is currently expanded.
 * Instantiated per section mount via `useState(() => new QRSectionStore())`.
 */
export class QRSectionStore {
    show = false

    constructor() {
        makeAutoObservable(this)
    }

    toggle(): void {
        this.show = !this.show
    }
}
